export default "__VITE_ASSET__CjIFzpHQ__"